import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  resolveOrganisationIdFromRoute,
  resolveTenantIdFromRoute,
} from './resolve-organisation-id-from-route';

@Pipe({
  name: 'orgRelativeLink',
  pure: true,
  standalone: false,
})
export class OrganisationRelativeLink implements PipeTransform {
  constructor(private route: ActivatedRoute) {}

  transform(link: string[], organisationId?: string) {
    const tenantId = resolveTenantIdFromRoute(this.route);
    const orgId = organisationId ?? resolveOrganisationIdFromRoute(this.route);
    if (!orgId) {
      return;
    }
    if (Array.isArray(link)) {
      return ['/', tenantId, `organisations`, orgId, ...link];
    }
    return ['/', tenantId, 'organisations', orgId, link];
  }
}
